import { defineStore } from "pinia";
import { reactive } from "vue";

export const useFormStore = defineStore("form", {
  state: () => ({
    formData: reactive({
      voucherValue: 100,
      selfVoucher: "true",
      quantity: 1,
      splitWithFriends: false,
      deliveryMethod: 'printable', // Simplified to a single string
      from: '',
      recipientName: '',
      recipientEmail:'',
      giftMessage: '',
      hideDetails: false,
      fullName: "",
      email: "",
      confirmEmail: "",
      phoneNumber: "",
      country: "Ireland",
      acceptTerms: false,
      newsletter: false,
      paymentMethod: null,
      discountCode: "",
      discountApplied: false,
      discountAmount: 0,
      postalFee: 5,
      processingFee: 0,
      deliveryDetails: {
        postalRecipientName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        scheduleLater: false,
        scheduleDate: null,
      },
      clientReference: "",
    }),
    currentStepIndex: 0,
    loading: false,
    error: null,
    downloading: {
      download: false,
      open: false,
    },
  }),
  actions: {
    setStepDirectly(stepIndex) {
    this.currentStepIndex = stepIndex;
  },
    updateFormData(payload) {
      Object.assign(this.formData, payload);
      // console.log('Form data updated:', JSON.stringify(this.formData, null, 2))
    },
    nextStep() {
      // console.log('Next step. Current index:', this.currentStepIndex)
      if (this.formData.deliveryMethod == "scheduledEmail") {
        this.formData.deliveryDetails.scheduleLater = true;
        // this.formData.deliveryDetails.scheduleDate = null
      }
      if (this.currentStepIndex < 4) {
        this.currentStepIndex++;
      }
      // console.log('New index:', this.currentStepIndex, 'Form data:', JSON.stringify(this.formData, null, 2))
    },
    prevStep() {
      // console.log('Prev step. Current index:', this.currentStepIndex)
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
      }
      // console.log('New index:', this.currentStepIndex, 'Form data:', JSON.stringify(this.formData, null, 2))
    },
    applyDiscount() {
      if (this.formData.discountCode) {
        const subtotal = this.formData.voucherValue * this.formData.quantity;
        this.formData.discountAmount = subtotal * 0.1;
        this.formData.discountApplied = true;
      }
      console.log("Discount applied:", JSON.stringify(this.formData, null, 2));
    },
    resetForm() {
      Object.assign(this.formData, {
        voucherValue: 100,
        quantity: 1,
        splitWithFriends: false,
        deliveryMethod: "email",
        from: "",
        recipientName: "",
        giftMessage: "",
        hideDetails: false,
        fullName: "",
        email: "",
        confirmEmail: "",
        phoneNumber: "",
        country: "Ireland",
        acceptTerms: false,
        newsletter: false,
        paymentMethod: null,
        discountCode: "",
        discountApplied: false,
        discountAmount: 0,
        postalFee: 5,
        deliveryDetails: {
          postalRecipientName: "",
          address1: "One",
          address2: "",
          city: "",
          state: "",
          postalCode: "",
          country: "",
        },
      });
      this.currentStepIndex = 0;
      this.error = null;

      // console.log('Form reset:', JSON.stringify(this.formData, null, 2))
    },
    async completePurchase() {
      this.loading = true;
      this.error = null;
      try {
        let body = JSON.parse(JSON.stringify(this.formData));
        body.postalFee =
          this.formData.deliveryMethod == "postal"
            ? this.formData.postalFee
            : 0;
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/v1/promotions/create_voucher_checkout`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to complete purchase");
        }
        const data = await response.json();
        // Redirect to Stripe Checkout
        window.location.href = data.url;
      } catch (error) {
        this.error = error.message;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    // async downloadVoucher(processType = "download",voucherNo) {
    //   this.downloading[processType] = true;
    //   try {
    //     const response = await fetch(
    //       `${process.env.VUE_APP_API_URL}/api/v1/promotions/download_voucher?id=${voucherNo}`,
    //       {
    //         method: "GET",
    //         // Remove the Accept header to let the server decide the content type
    //       }
    //     );
    
    //     if (!response.ok) throw new Error("Failed to fetch voucher");
    
    //     const contentType = response.headers.get('content-type');
    //     const blob = await response.blob();
    
    //     if (contentType.includes('application/zip')) {
    //       // Handle ZIP file download
    //       if (processType === "download") {
    //         const link = document.createElement("a");
    //         link.href = window.URL.createObjectURL(blob);
    //         link.download = "vouchers.zip";
    //         document.body.appendChild(link);
    //         link.click();
    
    //         // Clean up after download
    //         setTimeout(() => {
    //           document.body.removeChild(link);
    //           window.URL.revokeObjectURL(link.href);
    //         }, 100);
    //       } else {
    //         // For preview, we can extract and show one of the PDFs
    //         // Note: Browser-side ZIP extraction is complex, might want to reconsider this flow
    //         const pdfUrl = URL.createObjectURL(blob);
    //         window.open(pdfUrl, "_blank");
    
    //         // Store URL for later cleanup
    //         this.tempUrls = this.tempUrls || [];
    //         this.tempUrls.push(pdfUrl);
    //       }
    //     } else if (contentType.includes('application/pdf')) {
    //       // Original PDF handling
    //       if (processType === "download") {
    //         const link = document.createElement("a");
    //         link.href = window.URL.createObjectURL(blob);
    //         link.download = "voucher.pdf";
    //         document.body.appendChild(link);
    //         link.click();
    
    //         // Clean up after download
    //         setTimeout(() => {
    //           document.body.removeChild(link);
    //           window.URL.revokeObjectURL(link.href);
    //         }, 100);
    //       } else {
    //         const pdfUrl = URL.createObjectURL(blob);
    //         window.open(pdfUrl, "_blank");
    
    //         // Store URL for later cleanup
    //         this.tempUrls = this.tempUrls || [];
    //         this.tempUrls.push(pdfUrl);
    //       }
    //     } else {
    //       throw new Error("Unknown content type received");
    //     }
    //   } catch (error) {
    //     this.error = error.message;
    //     throw error;
    //   } finally {
    //     this.downloading[processType] = false;
    //   }
    // },
async downloadVoucher(processType = "download", voucherNo) {
  const _self = this;
  this.downloading[processType] = true;

  try {
    const response = await fetch(
      `${process.env.VUE_APP_API_URL}/api/v1/promotions/download_voucher?id=${voucherNo}`,
      { method: "GET" }
    );

    if (!response.ok) throw new Error("Failed to fetch voucher");
    const contentDisposition = response.headers.get('content-disposition');
    console.log(contentDisposition)

    const contentType = response.headers.get("Content-Type") || "";

    if (contentType.includes("application/json")) {
      const data = await response.json();
      const pdfUrls = data.pdf_urls || [];

      if (pdfUrls.length === 0) {
        _self.downloadingVoucher = null;
        console.error("No PDFs found in response");
        return;
      }

      // Sequentially download each PDF
      const downloadNext = async (index = 0) => {
        if (index >= pdfUrls.length) {
          _self.downloadingVoucher = null;
          return;
        }

        const { filename } = pdfUrls[index];
        try {
          const pdfResponse = await fetch(
            `${process.env.VUE_APP_API_URL}/api/v1/promotions/download_pdf_voucher?file_name=${filename}`,
            { method: "GET" }
          );

          if (pdfResponse.status !== 200) {
            throw new Error(`Failed to fetch PDF: ${filename}`);
          }

          const blob = await pdfResponse.blob();
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();

          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }, 100);

          // Wait before next download
          setTimeout(() => downloadNext(index + 1), 500);
        } catch (error) {
          console.error("Download error:", error.message);
          _self.downloadingVoucher = null;
        }
      };

      downloadNext(); // Start downloading
    } else if (contentType.includes("application/pdf")) {
      // Case: API returned a single PDF directly
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const filename = _self.getFileNameFromContentDisposition(contentDisposition);

      link.download = filename;
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        _self.downloadingVoucher = null;
      }, 100);
    } else {
      throw new Error(`Unexpected content type: ${contentType}`);
    }
  } catch (error) {
    this.error = error.message;
    console.error("Download voucher error:", error.message);
    throw error;
  } finally {
    this.downloading[processType] = false;
  }
},

 getFileNameFromContentDisposition(header) {
  console.log(header)
  const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(header);
  if (match != null && match[1]) {
    return match[1].replace(/['"]/g, '');
  }
  return null;
},
    async openVoucher(router) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/v1/promotions/download_voucher${router.parms.voucherNo}`,
          {
            method: "GET",
            headers: {
              Accept: "application/pdf",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch voucher");
        }

        // Create a Blob from the response
        const blob = await response.blob();

        // Create an object URL for the blob
        const pdfUrl = URL.createObjectURL(blob);

        // Open the PDF in a new tab
        window.open(pdfUrl, "_blank");

        // Clean up the object URL after some time (optional)
        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
        }, 1000);
      } catch (error) {
        this.error = error.message;
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
  getters: {
    totalAmount(state) {
      const subtotal = state.formData.voucherValue * state.formData.quantity;

      // const stripePercentageFee = 0.015; // 1.5% for standard EEA cards
      // const stripeFixedFee = 0.25; // €0.25 per transaction
      // const processingFee = subtotal * stripePercentageFee + stripeFixedFee;
      const processingFee = subtotal <= 100 ? 1 : 1.94
      state.formData.processingFee = processingFee
      const postalFee =
        state.formData.deliveryMethod === "postal"
          ? state.formData.postalFee * state.formData.quantity
          : 0;
      return (
        subtotal +
        processingFee +
        postalFee -
        (state.formData.discountAmount || 0)
      );
    },
  },
});
